<template>
    <div class="langSelect">
        <el-dropdown trigger="click" style="cursor: pointer;">
            <span class="el-dropdown-link"> 
                <div class="langTitle">{{ $t("login.changeLanguage") }}</div>
            </span>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in language" :disabled="item.key == chooseLanguage ? true : false"
                    :key="item.key" :label="item.value" :value="item.key"
                    @click.native="handleChangeLanguage(item.key)">{{ item.value }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
    name: 'changeLang',
    data() {
        return {
            language: [
                { "key": "zh-CN", "value": "简体中文" },
                { "key": "zh-TW", "value": "繁體中文" },
                { "key": "en-US", "value": "English" },
                { "key": "id-ID", "value": "Indonesia" }
            ],
            chooseLanguage: this.$i18n.locale,
        }
    },
    created() {
        this.setWebLanguage();
    },
    methods: {
        handleChangeLanguage(languageKey) {
            console.log("languageKey:" + languageKey);
            // 用户修改了显示语言，重新设置语言
            this.chooseLanguage = languageKey;

            // 临时保存到cookies中，后面由具体的方法去处理
            Cookies.set("flowinnIotLanguage", this.chooseLanguage, { expires: 30 });
            this.setWebLanguage();
            window.location.reload(true)
        },
        setWebLanguage() {
            // cookies中是刚才用户选择的语言
            let language = Cookies.get("flowinnIotLanguage");
            if (language != null && language != "" && language != undefined) {
                this.chooseLanguage = language;
            } else {
                // 如果cookies中没有，说明用户第一次打开系统，直接获取系统的语言
                let systemLanguage = (navigator.language || navigator.userLanguage).substring(0, 2);
                if (systemLanguage != null && systemLanguage != "" && systemLanguage != undefined) {
                    // 这里获取到的是zh和es，不是zh-CN需要单独处理
                    this.chooseLanguage = systemLanguage;
                }
            }
            if (this.chooseLanguage == "zh" || this.chooseLanguage == "zh-CN") {
                this.chooseLanguage = "zh-CN";
            }
            var time = new Date().getTime();
            // 设置一个3年的有效期
            let timeNum = time + (3 * 365 * 24 * 60 * 60);
            Cookies.set("flowinnIotLanguage", this.chooseLanguage, { expires: timeNum });
            // 保存到全局变量中，后面可以使用
            localStorage.setItem("language", this.chooseLanguage);
            // 页面刷新语言进行显示
            this.$i18n.locale = this.chooseLanguage;
            // 修改页面标题
            document.title = this.$i18n.t('login.formTitle');
        },
    }
}
</script>

<style scoped>
.langSelect {
    color: #00549e;
}

.langTitle {
    color: #000;
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/changeLang.vue